import { OrbitalInsightSatelliteType, OrbitStartOptionsType, Orbit, ExposureTiming } from "./orbital-insights-type";

export const getAllOrbitNames = (data: OrbitalInsightSatelliteType | null, orbitStartOption: OrbitStartOptionsType) => {
    if (!data) return []
    const orbits: string[] = ['All Orbits']
    const option = orbitStartOption === 'Sunlit' ? 'orbitsEndingWithEclipse' : 'orbitsByOrbitalPeriod'
    data?.[option]?.forEach((orbit) => {
        const name = `Orbit ${orbit.orbitNumber}`
        if (!orbits.includes(name)) {
            orbits.push(name)
        }
    })
    return orbits
}

export const getOrbitalInsightDetails = (data: OrbitalInsightSatelliteType | null, orbitStartOption: OrbitStartOptionsType) => {
    if (!data) return []
    const option = orbitStartOption === 'Sunlit' ? 'orbitsEndingWithEclipse' : 'orbitsByOrbitalPeriod'
    return data?.[option] || []
}

export const getCurrentOrbitExposure = (orbits: Orbit[], currentTime: number) => {
    const orbit = orbits.find(o => currentTime >= o.orbitStartTime && currentTime <= o.orbitEndTime) ?? null;
    const exposure = orbit?.exposureTimings.find(e => currentTime >= e.startTime && currentTime <= e.endTime) ?? null;
    return { orbit, exposure };
}